import api from 'ApiConfig';

const practicalTestService = {
  getAssignedTests: async () => {
    return api.post('/student/get-assigned-practical-tests');
  },
  submitTest: async (formData) => {
    return api.post('/student/submit-practical-test', formData);
  },
  requestDriveLinkPermission: async (testId) => {
    return api.post('/student/request-drive-link-permission', { testId });
  },
  uploadDriveLink: async (testId, driveLink) => {
    return api.post('/student/upload-drive-link', { testId, driveLink });
  },
  getMySubmissions: async () => {
    return api.post('/student/get-my-practical-submissions');
  },
};

export default practicalTestService;
